// todo - this will be updated after api call is added
export interface VisualSearchProduct {
  asin: string;
}

export interface VisualSearchData {
  products: VisualSearchProduct[];
}

export enum VisualSearchAPIResponse {
  UNKNOWN,
  FETCHING,
  FETCHED,
  FAILED
}

export interface QnaItem {
  question: string;
  answer: string;
}
